import React from "react";
import Badge, { BadgeColor } from "./Badge.tsx";

/**
 * Os 5 status reais de Cirurgia (StatusCirurgia, enum do backend) —
 * ver CONTEXTO_TECNICO_COMPLETO_SISTEMA.md secao 7.7. Nao inventar status novo.
 */
export type StatusCirurgia = "AGENDADA" | "SEPARADO" | "REALIZADA" | "CANCELADA" | "ABERTO";

const STATUS_MAP: Record<StatusCirurgia, { label: string; color: BadgeColor }> = {
  AGENDADA: { label: "Agendada", color: "blue" },
  SEPARADO: { label: "Separado", color: "orange" },
  REALIZADA: { label: "Realizada", color: "green" },
  CANCELADA: { label: "Cancelada", color: "red" },
  ABERTO: { label: "Aberto", color: "teal" },
};

export const statusColor = (status: string): BadgeColor =>
  STATUS_MAP[status as StatusCirurgia]?.color ?? "neutral";

const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const info = STATUS_MAP[status as StatusCirurgia];
  return <Badge color={info?.color ?? "neutral"}>{info?.label ?? status}</Badge>;
};

export default StatusBadge;
